import { object, string } from 'yup';

export interface CustomerFormProps {
  address: string;
  city: string;
  company_name: string;
  email: string;
  phone_number: string;
  tax_code: string;
  zip_code: string;
}

export enum CustomerType {
  CompanyAlias = 'company_alias',
  NotSet = 'not_set',
  Supervisor = 'supervisor'
}
// enum('not_set','common','supervisor','company','company_alias','admin')

export const CustomerFormSchema = object().shape({
  address: string().required('errors.address is required'),
  city: string().required('errors.city is required'),
  email: string()
    .email('errors.email is not valid')
    .required('errors.email is required'),
  company_name: string().required('errors.company_name is required'),
  phone_number: string().required('errors.phone_number is required'),
  tax_code: string().required('errors.tax code is required'),
  zip_code: string().required('errors.postal_code is required')
});
